import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthService).getAccessToken();
  // Solo agregar token si la petición va a nuestro API
  if (!token || !req.url.startsWith(environment.apiUrl)) return next(req);

  return next(req.clone({
    setHeaders: { Authorization: token }
  }));
};
